/**
 * dav app 的hook，用户登录hook，用户登录时触发事件
 */
import EventBus, { EventTypes } from '@common/utils/event-bus';

export default function localLoadEndHook() {
  return () => (next) => (action) => {
    if (!action) {
      return next(action);
    }

    // 需要try-catch,避免emitter事件监听器中抛出的异常，引起dva崩溃
    try {
      const { type = '', payload = {} } = action;
      // 新打开了tab
      if (type === 'global/addTab') {
        EventBus.emitter.emit(EventTypes.ADD_TAB, payload);
      }
      // 标签页更新
      if (type.startsWith('global/')) {
        if (payload?.activeTabKey || payload?.newTab?.key) {
          EventBus.emitter.emit(EventTypes.ACTIVE_TAB_CHANGE, {
            nextTabKey: payload?.activeTabKey || payload?.newTab?.key,
            actionType: payload?.activeTabKey ? 'switch' : 'add',
          });
        }
      }
      // 关闭了Tab
      if (type === 'global/removeTab') {
        EventBus.emitter.emit(EventTypes.REMOVE_TAB, payload);
      }
    } catch (err) {
      /** noop */
    }
    return next(action);
  };
}
